import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getBaseUrl } from '../../Utils'

interface ItemState {
    items: any[] // Use any[] if the type is not clear, but ideally define an interface
    status: 'idle' | 'loading' | 'succeeded' | 'failed'
    error: string | null
}

const initialState: ItemState = {
    items: [],
    status: 'idle',
    error: null,
}

async function SearchMetaDataDrillThru(MdsName: string) {
    const response = await axios.get(`${getBaseUrl()}/API/v3/MetadataDrillThru/Search`, {
        params: {
            MdsName: MdsName,
        },
    })
    return response.data.data.mdsTable
}

export const MetadataDrillThruItem = createAsyncThunk('items/createItem', SearchMetaDataDrillThru)

const MDSTool = createSlice({
    name: 'MDSTool',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(MetadataDrillThruItem.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(MetadataDrillThruItem.fulfilled, (state, action) => {
                state.status = 'succeeded'
                state.items = action.payload
            })
            .addCase(MetadataDrillThruItem.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message || 'Please enter valid query in the box'
            })
    },
})

export default MDSTool.reducer
